<template>
  <div
    class=""
    v-loading="queryLoading"
    :class="`flex flex-dir-column app-layout orver-hidden-x ${query ? 'active' : ''}`"
  >
    <!-- 顶部搜索的表单 -->
    <el-tooltip class="item" effect="dark" placement="top-start">
      <div slot="content">
        页面名称：{{ routerInfo.pageName }}<br />
        事件名称：{{ routerInfo.eventName }}<br />
        事件标识：{{ routerInfo.eventCode }}
      </div>
      <div
        class="overflow-hidden"
        style="white-space: nowrap; text-overflow: ellipsis; padding-left: 20px; padding-top:20px"
      >
        <strong class="font-size-20 bold">
          {{ routerInfo.pageName }}
          <template v-if="routerInfo.eventName">:</template>
          {{ routerInfo.eventName }}
        </strong>
        <span class="font-size-12 padding-left-10" style="color: #999">{{
          routerInfo.eventCode
        }}</span>
      </div>
    </el-tooltip>
    <div class="flex top-search">
      <el-form
        class="margin-left-20"
        size="small"
        ref="topForm"
        :model="topSearchData"
        label-width="80px"
        :inline="true"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <div class="flex">
                <el-radio-group
                  v-model="dateType"
                  size="small"
                  @change="handleDateUpdate"
                >
                  <el-radio-button
                    :label="item.value"
                    v-for="item in dateList"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
                <div class="flex-1 padding-left-20">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    size="small"
                    class="analyze-relation-range"
                    v-model="formQuery.range"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    :unlink-panels="true"
                    end-placeholder="结束日期"
                    :clearable="false"
                    @change="handleRangeUpdate"
                  />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="选择部门"
              prop="organizationId"
            >
              <OrganizationCascader
                v-model="formQuery.organizationId"
                type="auth"
                collapseTags
                size="mini"
              ></OrganizationCascader>
            </el-form-item>
            <el-form-item label="系统">
              <el-select @change="osInfosChange" v-model="formQuery.os" placeholder="请选择系统">
                <el-option
                  v-for="item in osInfos"
                  :key="item.os"
                  :label="item.os"
                  :value="item.value === undefined ? item.os : item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本">
              <el-select
                style="width: 100%"
                @change="handleQueryData"
                v-model="formQuery.osVersion"
                placeholder="请选择版本"
                clearable
              >
                <el-option
                  v-for="(item, index) in osVersions"
                  :key="`osVersion-${index}`"
                  :label="item.os === undefined ? item : item.os"
                  :value="item.value === undefined ? item : item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-button size="small" type="primary" @click="handleQueryData(1)">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-card
      class="flex-1 box-card box-card-echart"
      shadow="never"
      :body-style="{ padding: '0 20px' }"
    >
      <el-card class="box-card margin-bottom-20" shadow="never">
        <!-- 顶部各种总数据，还未传参 -->
        <totalData :data="eventCountData"></totalData>
      </el-card>
      <el-card class="box-card" shadow="never">
        <!-- 选项菜单 -->
        <el-tabs v-model="activeIndex" @tab-click="queryChartData">
          <el-tab-pane label="用户统计" name="1">
            <!-- 条件选择表单 -->
            <div class="condition-form">
              <div class="userCondition">
                <Echart
                  isMountedRender
                  ref="userConEchart"
                  :id="'userCondition'"
                  :data="chartData"
                  isMultipleX
                ></Echart>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户TOP统计" name="2">
            <top-form
              @change="
                (topCount) => {
                  formQuery.topCount = topCount;
                  queryChartData();
                }
              "
            ></top-form>
            <div class="userTOP">
              <Echart
                :id="'userTOP'"
                :data="chartData2"
                :xType="'value'"
                :yType="'category'"
                :xShow="false"
                showData
                :type="'bar'"
              ></Echart>
            </div>
          </el-tab-pane>
          <el-tab-pane label="应用信息统计" name="3">
            <div class="sys-pie flex">
              <div
                class="padding-right-10 sys-pie-item"
                v-for="(item, index) in chartData3"
                :key="index"
              >
                <Echart isMountedRender :type="'pie'" :data="item" :id="`userSys${index}`"></Echart>
              </div>
            </div>
            <div class="app-bar">
              <div
                class="app-bar-item"
                v-for="(item, index) in chartData4"
                :key="`chartData4_${index}`"
              >
                <div class="app-bar-title">系统版本({{ item.name }})</div>
                <Echart
                  isMountedRender
                  :type="'more'"
                  :data="item.data"
                  :id="`userSysbarAPPios_${index}`"
                ></Echart>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="明细数据" name="4">
            <div class="sys-detail flex flex flex-column">
              <el-table
                height="100%"
                :data="tableData"
                v-loading="queryLoading"
                size="mini"
                stripe
              >
                <el-table-column
                  v-for="(item, index) in columnsList"
                  :key="index"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :label="item.label"
                  :prop="item.prop"
                  :fixed="item.fixed"
                  :sortable="item.sortable"
                >
                  <template slot="header">
                    <template v-if="item.prop === 'operate'">
                      <el-button
                        size="mini"
                        type="success"
                        @click="handleExport"
                      >导出
                      </el-button>
                    </template>
                    <template v-else>{{ item.label }}</template>
                  </template>
                  <!-- <template #default="{ row }" v-if="item.tmpl">
                    <template v-if="item.label === '触发时间'">
                      {{ row.eventTime | formatTime }}
                    </template>
                  </template> -->
                </el-table-column>
              </el-table>
              <el-row class="padding-top-10">
                <el-col align="right">
                  <el-pagination
                    class="analyze-users-pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="tableQuery.pageNum"
                    :page-sizes="[20, 50, 100, 200, 300, 400]"
                    :page-size="tableQuery.pageSize"
                    :total="tableQuery.total"
                  ></el-pagination>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Echart from '@/views/components/echart/index.vue';
import totalData from '@/views/event-manage/component/total-data/index.vue';
import topForm from '@/views/event-manage/component/top-form/index.vue';
import OrganizationCascader from '@/views/components/organization-cascader/index.vue';
import {
  queryEventCount,
  queryEventDetail,
  queryOsInfo,
  queryEventCountTendency,
  queryEventUserTop,
  queryEventOsStat,
  queryEventOsVersionTendency,
  eventAnalyzeExport,
} from '@/api/event';
import exportByBlobMixsin from '@/mixins/file-download';

export default {
  components: {
    totalData, Echart, topForm, OrganizationCascader,
  },
  mixins: [exportByBlobMixsin],
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  props: {
    query: {
      type: Object,
      default: () => (null),
    },
  },
  data() {
    return {
      tableQuery: {
        pageNum: 1,
        pageSize: 20,
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf- 8 ',
          },
        ],
      ],
      json_fields: {
        用户ID: 'visitorId', // 常规字段
        用户名称: 'userName', // 支持嵌套属性
        所属部门名称: 'organizationName',
        系统: 'os',
        版本: 'osVersion',
        触发时间: 'eventTime',
      },
      columnsList: [
        {
          label: '用户ID',
          minWidth: 60,
          prop: 'visitorId',
        },
        {
          label: '用户名称',
          minWidth: 150,
          prop: 'userName',
        },
        {
          label: '所属部门名称',
          minWidth: 150,
          prop: 'organizationName',
        },
        {
          label: '系统',
          prop: 'os',
        },
        {
          label: '版本',
          minWidth: 100,
          prop: 'osVersion',
        },
        {
          label: '触发时间',
          minWidth: 200,
          prop: 'eventTime',
        },
        {
          label: '操作',
          prop: 'operate',
        },
      ],
      routerInfo: {
        eventId: '',
        eventCode: '',
        eventName: '',
        pageName: '',
      },
      sysBarselect: '全部系统',
      dateType: '0',
      dateList: [{
        value: '0',
        label: '今日',
      }, {
        value: '1',
        label: '昨日',
      }, {
        value: '2',
        label: '最近7天',
      }, {
        value: '3',
        label: '最近30天',
      }],
      chartData: {
        legend: ['选中时间段', '对比时间段'],
        x: [
          {
            data: [0],
          },
          {
            data: [0],
          },
        ],
        y: [
          {
            name: '选中时间段',
            data: [],
          },
          {
            name: '对比时间段',
            data: [],
          },
        ],
      },
      chartData2: {
        x: ['暂无数据'],
        y: [0],
      },
      chartData3: [],
      chartData4: [],
      activeIndex: '1',
      topSearchData: {
        date: [],
        system: 'web',
        version: '',
      },
      //   各种下拉框选项列表
      systems: [
        { label: 'web', value: 'web' },
        { label: 'app', value: 'app' },
      ],
      versions: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      browsers: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      dateScope: [{ label: '自定义', value: '1' }],
      formQuery: {
        range: [],
        organizationId: [],
        osVersion: '',
        os: '',
        topCount: 10,
      },
      osInfos: [],
      osVersions: [],
      eventCountData: [
        { name: '触发总次数', data: 0 },
        { name: '用户数(uv)', data: 0 },
      ],
      queryLoading: false,
      tableData: [],
    };
  },
  mounted() {
    // const today = moment().format('YYYY-MM-DD');
    // const today2 = moment().subtract(7, 'days').format('YYYY-MM-DD');
    // this.formQuery.range = [new Date(today2), new Date(today)];
    const {
      eventId, eventCode, eventName, pageName, organizationId, range, dateType,
    } = this.query || this.$route.query;

    console.log(eventId, eventCode, eventName, pageName, organizationId, range);
    if (eventId) {
      this.formQuery.organizationId = organizationId;
      this.formQuery.range = range;
      this.dateType = dateType || '0';
      Object.assign(this.routerInfo, {
        eventId,
        eventCode,
        eventName,
        pageName,
      });
      console.log(this.routerInfo);
      if (!range.length) {
        this.setDefaultRange();
      }
      // this.setDefaultRange();
      this.queryOsInfo();
    }
  },
  watch: {
    // query: {
    //   handler(val) {
    //     console.log('???', val);
    //     const {
    //       eventId, eventCode, eventName, pageName,
    //     } = val;
    //     Object.assign(this.routerInfo, {
    //       eventId,
    //       eventCode,
    //       eventName,
    //       pageName,
    //     });
    //     this.setDefaultRange();
    //     this.queryOsInfo();
    //   },
    //   deep: true,
    // },
    source: {
      handler() {
        this.queryOsInfo();
      },
    },
    env: {
      handler() {
        this.queryOsInfo();
      },
    },
  },
  methods: {
    handleExport() {
      const { eventId, eventCode, eventName } = this.routerInfo;
      const { range: [analyzeTimeFrom, analyzeTimeTo], organizationId } = this.formQuery;
      const data = {
        eventId,
        eventCode,
        eventName,
        downloadType: 'detail',
        analyzeTimeTo,
        analyzeTimeFrom,
        organizationIdList: organizationId,
      };
      this.exportByBlob({
        url: eventAnalyzeExport,
        data,
      });
    },
    handleRangeUpdate() {
      this.dateType = '';
      this.handleQueryData();
    },
    /**
     * 设置默认的时间周期
     */
    setDefaultRange() {
      this.handleDateUpdate();
    },
    // 日期快捷操作
    handleDateUpdate() {
      let days = 0;
      let lastDays = 0;
      switch (this.dateType) {
        case '0': days = 0; break;
        case '1': days = 1; lastDays = 1; break;
        case '2': days = 7; break;
        case '3': days = 30; break;
        default: break;
      }
      this.formQuery.range = [
        `${moment().subtract(days, 'days').format('YYYY-MM-DD')}`,
        `${moment().subtract(lastDays, 'days').format('YYYY-MM-DD')}`,
      ];
    },
    async queryOsInfo() {
      this.queryLoading = true;
      try {
        const { range: [analyzeTimeFrom, analyzeTimeTo], organizationId } = this.formQuery;
        const data = {
          analyzeTimeTo,
          analyzeTimeFrom,
          organizationIdList: organizationId,
        };
        const {
          data: { osInfos },
        } = await queryOsInfo(data);
        this.osInfos.splice(0, this.osInfos.length, ...[{ os: '全部', value: '' }, ...osInfos]);

        this.formQuery.os = '';
        this.osInfosChange();
        this.handleQueryData();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventUserTop(data) {
      this.queryLoading = true;
      try {
        const { topCount, organizationId } = this.formQuery;
        const {
          data: { eventUserTops },
        } = await queryEventUserTop({ ...data, topCount, organizationId });

        const xList = [];
        const yList = [];
        if (!eventUserTops.length) {
          xList.push('暂无数据');
          yList.push(0);
        } else {
          eventUserTops.reverse();
          eventUserTops.forEach(({ userName, count }) => {
            xList.push(
              userName
                .split('')
                .map((item, index) => (!((index + 1) % 10) ? `${item}\n` : item))
                .join(''),
            );
            yList.push(count);
          });
        }
        this.chartData2.x.splice(0, this.chartData2.x.length, ...xList);
        this.chartData2.y.splice(0, this.chartData2.y.length, ...yList);

        // chartData2: {
        //   x: ['用户', '用户', '用户', '用户', '用户', '用户'],
        //   y: [1, 2, 3, 4, 5, 6],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventCountTendency(data) {
      this.queryLoading = true;
      try {
        const {
          data: { eventCounts },
        } = await queryEventCountTendency(data);
        const xList = [
          {
            data: [],
          },
          {
            data: [],
          },
        ];
        const yList = [
          {
            name: '对比时间段',
            data: [],
          },
          {
            name: '选中时间段',
            data: [],
          },
        ];
        if (!eventCounts.length) {
          const { analyzeTimeTo, analyzeTimeFrom } = data;
          const days = moment(analyzeTimeTo).diff(moment(analyzeTimeFrom), 'days') + 1;

          // 计算相差多少天
          for (let i = 0, len = days; i < len; i++) {
            xList[0].data.push(
              moment(analyzeTimeFrom)
                .subtract(i, 'days')
                .format('YYYY-MM-DD'),
            );
            xList[1].data.push(
              moment(analyzeTimeTo)
                .subtract(i, 'days')
                .format('YYYY-MM-DD'),
            );
            yList[0].data.push(0);
            yList[1].data.push(0);
          }
        } else {
          // eslint-disable-next-line object-curly-newline
          eventCounts.forEach(({ currentAnalyzeTime, referAnalyzeTime, current, refer }) => {
            xList[0].data.push(currentAnalyzeTime);
            xList[1].data.push(referAnalyzeTime);
            yList[0].data.push(refer);
            yList[1].data.push(current);
          });
        }
        this.chartData.x.splice(0, this.chartData.x.length, ...xList);
        this.chartData.y.splice(0, 2, ...yList);
        this.chartData.legend = ['选中时间段', '对比时间段'];
        // chartData: {
        //   x: [1, 2, 3, 4, 5, 6],
        //   y: [{ name: '测试1', data: [2, 3, 4, 5, 6] },
        //     { name: '测试2', data: [4, 2, 1, 9, 10] },],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventOsStat(data) {
      this.queryLoading = true;
      try {
        const {
          data: {
            osStat: { osStatItems },
            osVersionStats,
          },
        } = await queryEventOsStat(data);

        const promiseList = [];
        const chartData4 = [];

        osStatItems.forEach(async (item, index) => {
          osStatItems[index] = {
            name: item.os,
            value: item.count,
          };
          promiseList.push(
            queryEventOsVersionTendency({
              ...data,
              os: item.os,
            }),
          );
          chartData4[index] = { name: item.os };
        });

        if (!osStatItems.length) {
          osStatItems[0] = {
            name: '暂无数据',
            value: 1,
          };
        }

        const chartData3 = [
          {
            name: `${data.os || '全部'}\n\n系统分布`,
            data: osStatItems,
          },
        ];
        osVersionStats.forEach(({ os, osVersionStatItems }) => {
          const chartItemData = [];
          osVersionStatItems.forEach(({ osVersion, count }) => {
            chartItemData.push({
              value: count,
              name: osVersion,
            });
          });
          chartData3.push({
            name: os,
            data: chartItemData,
          });
        });

        if (!osVersionStats.length) {
          chartData3.push({
            name: '暂无数据',
            data: [
              {
                value: 0,
                name: '',
              },
            ],
          });
        }

        this.chartData3.splice(0, this.chartData3.length, ...chartData3);

        const res = await Promise.all(promiseList);
        res.forEach(({ data: { osVersionTendencies, osVersions } }, resIndex) => {
          const xAxis = [];
          const series = [];
          osVersions.forEach((version) => {
            series.push({
              name: version,
              type: 'bar',
              data: [],
            });
          });

          osVersionTendencies.forEach(({ analyzeTime, osVersionCounts }) => {
            xAxis.push(analyzeTime);
            if (osVersionCounts.length) {
              osVersionCounts.forEach(({ osVersion, count }) => {
                series.some(({ name }, seriesIndex) => {
                  if (name === osVersion) {
                    series[seriesIndex].data.push(count || 0);
                    return true;
                  }
                  return false;
                });
              });
            } else {
              series.forEach((item, index) => {
                series[index].data.push(0);
              });
            }
          });
          chartData4[resIndex].data = { xAxis, series };
        });

        // console.log('chartData4chartData4', chartData4);
        if (!chartData4.length) {
          chartData4.push({
            name: '暂无数据',
            data: {
              series: [
                {
                  data: [0],
                  name: '暂无数据',
                  type: 'bar',
                },
              ],
              xAxis: [moment(data.analyzeTimeFrom).format('YYYY-MM-DD')],
            },
          });
        }
        this.chartData4.splice(0, this.chartData4.length, ...chartData4);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async handleQueryData() {
      this.queryLoading = true;
      try {
        const { eventId, eventCode } = this.routerInfo;
        const {
          range: [analyzeTimeFrom, analyzeTimeTo],
          osVersion,
          os,
          organizationId,
        } = this.formQuery;
        const data = {
          eventId,
          eventCode,
          analyzeTimeTo,
          analyzeTimeFrom,
          osVersion,
          os,
          organizationId,
        };
        const {
          data: { eventCount, userCount },
        } = await queryEventCount(data);
        this.eventCountData[0].data = eventCount;
        this.eventCountData[1].data = userCount;

        this.queryChartData();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    queryChartData() {
      const { eventId, eventCode } = this.routerInfo;
      const {
        range: [analyzeTimeFrom, analyzeTimeTo],
        osVersion,
        os,
        organizationId,
      } = this.formQuery;
      const days = moment(analyzeTimeTo).diff(moment(analyzeTimeFrom), 'days') + 1;

      const data = {
        eventId,
        eventCode,
        analyzeTimeTo,
        analyzeTimeFrom,
        referAnalyzeTime: moment(analyzeTimeTo).subtract(days, 'days').format('YYYY-MM-DD'),
        osVersion,
        os,
        organizationIdList: [].concat(...organizationId),
      };
      switch (this.activeIndex) {
        case '1':
          this.queryEventCountTendency(data);
          break;
        case '2':
          this.queryEventUserTop(data);
          break;
        case '3':
          this.queryEventOsStat(data);
          break;
        case '4':
          // this.tableQuery.pageNum = 1;
          // this.tableQuery.pageSize = 20;
          this.queryEventDetail(data);
          break;
        default:
          break;
      }
    },
    handleSizeChange(size) {
      this.tableQuery.pageSize = size;
      this.tableQuery.pageNum = 1;
      this.queryChartData();
    },
    handleCurrentChange(num) {
      this.tableQuery.pageNum = num;
      this.queryChartData();
    },
    async queryEventDetail(data) {
      try {
        this.queryLoading = true;
        const {
          data: { list, total },
        } = await queryEventDetail({ ...data, ...this.tableQuery });

        this.tableQuery.total = Number(total);
        this.tableData.splice(0, this.tableData.length, ...list);
      } catch (e) {
        console.log(e);
      } finally {
        this.queryLoading = false;
      }
    },
    osInfosChange() {
      const filterData = this.osInfos.filter((item) => item.os === this.formQuery.os);

      const [{ osVersions = [] }] = filterData.length ? filterData : [{ osVersions: [] }];

      this.formQuery.osVersion = '';
      this.osVersions.splice(
        0,
        this.osVersions.length,
        ...[{ os: '全部', value: '' }, ...osVersions],
      );

      this.handleQueryData();
    },
  },
};
</script>
<style lang="scss" scoped>
.app-layout {
  height: calc(100vh - 0);
  min-width: 800px;
  margin: 15px 0 0;
  &.active {
    margin-top: 0;
    height: calc(100vh);
  }
}
.top-search {
  // position: fixed;
  // top: 90px;
  text-align: left;
  background: #fff;
  // min-width: 1200px;
  padding-top: 20px;
  padding-left: 20px;
  margin-bottom: 20px;
  z-index: 10;
}
.box-card {
  &-echart {
    margin-bottom: 20px;
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.sys-detail {
  height: calc(100vh - 450px);
}
.sys-bar {
  margin-top: 30px;
  text-align: left;
}
.app-bar {
  margin-top: 50px;
}
.app-bar-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 20px 0 10px;
}
.sys-pie {
  flex-wrap: wrap;
}
.sys-pie-item {
  width: 33%;
  min-width: 200px;
}
</style>
